import SectionIntroLoader from './versions/0.0.1/SectionIntroLoader';

export default SectionIntroLoader;
